import { SubmitOtpBody } from 'domain/types'
import { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppState } from 'state'
import { UserStatePayload } from 'hooks/useSignOAuth'
import jwtDecode from 'jwt-decode'
import { setUserSignedState } from 'state/user/actions'

export const useTotp = () => {
  const data = useSelector((state: AppState) => {
    return state.totp.otp
  })
  return data
}

export const useSubmitToken = () => {
  const [isLoading, setIsLoading] = useState(false)

  const dispatch = useDispatch()

  const handleStorePersistent = useCallback(
    (response: any) => {
      const token = response?.data?.access_token
      const decoded = jwtDecode<UserStatePayload>(token)

      if (decoded) {
        const { address, roles, totp_validated = false } = decoded

        dispatch(
          setUserSignedState({
            isSigned: true,
            expiry: new Date().getTime() + 6.5 * 24 * 3600 * 1000,
            account: address,
            roles,
            isTotpValidated: totp_validated,
          }),
        )
      }
      return response
    },
    [dispatch],
  )

  const submitOtp = useCallback(
    async (
      otpBody,
      onSucceed?: (otpBody: SubmitOtpBody) => void,
      onFailed?: () => void,
    ) => {
      setIsLoading(true)
      fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/backend-service/totp/validate`,
        {
          credentials: 'include',
          headers: [['Cache-Control', 'no-cache']],
          method: 'POST',
          body: JSON.stringify(otpBody),
        },
      )
        .then((res) => res.json())
        .then(handleStorePersistent)
        .then((res) => {
          setIsLoading(false)
          if (res.status_code !== 200) {
            throw res.error
          }
          onSucceed?.(res.data)
        })
        .catch((error) => {
          setIsLoading(false)
          onFailed?.()
        })
    },
    [handleStorePersistent],
  )

  return { submitOtp, isLoading }
}

export default useTotp
